<template>
    <div>
        <el-dialog title="业务咨询" :visible.sync="visible" width="890px" @close="handleDialogClose">
            <div class="dialog-content">
                <el-form :model="form" ref="dialogForm" label-width="0px" :rules="rules">
                    <el-form-item class="half-width" prop="name">
                        <el-input v-model="form.name" placeholder="请输入公司名称"></el-input>
                    </el-form-item>
                    <el-form-item class="half-width" prop="email">
                        <el-input v-model="form.email" placeholder="请输入公司邮箱"></el-input>
                    </el-form-item>
                    <el-form-item class="half-width" prop="appointmentTime">
                        <el-date-picker v-model="form.appointmentTime" placeholder="请输入预约时间"
                            style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item class="half-width" prop="address">
                        <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                    <el-form-item class="half-width" prop="contacts">
                        <el-input v-model="form.contacts" placeholder="请输入联系人"></el-input>
                    </el-form-item>
                    <el-form-item class="half-width" prop="phone">
                        <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item class="full-width" prop="demand">
                        <el-input v-model="form.demand" type="textarea" placeholder="请输入您的需求"></el-input>
                    </el-form-item>
                    <el-form-item prop="agreement">
                        <el-checkbox v-model="form.agreement">
                            勾选表示：您同意华软及其授权的合作伙伴通过填写的联系方式联系您，且数据仅用于与您沟通。
                        </el-checkbox>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <!-- <el-button @click="closeDialog">取消</el-button> -->
                    <el-button type="primary" :disabled="!form.agreement" @click="handleSubmit">
                        立即咨询
                    </el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 新增：提交成功提示弹窗 -->
        <!-- <el-dialog :visible.sync="dialogVisible" width="500px" class="consult-dialog2" :show-close="false" center>
            <div class="dialog-content2" style="text-align:center;">
                <div class="icon" style="font-size:48px;color:#67C23A;margin-bottom:16px;">
                    <i class="el-icon-success"></i>
                </div>
                <p>信息已提交，请耐心等待...</p>
                <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>

<script>
import { consultationLogAdd } from "@/api/log.js";
export default {
    name: 'ConsultDialog',
    props: {
        visible: {
            type: Boolean,
            required: true,
        },

    },
    data() {
        return {

            form: {
                name: '',
                email: '',
                appointmentTime: '',
                address: '',
                contacts: '',
                phone: '',
                demand: '',
                agreement: false,
            },
            // 新增：表单校验规则
            rules: {
                name: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入公司邮箱', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                ],
                appointmentTime: [
                    { required: true, message: '请输入预约时间', trigger: 'change' }
                ],
                address: [
                    { required: true, message: '请输入详细地址', trigger: 'blur' }
                ],
                contacts: [
                    { required: true, message: '请输入联系人', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ],
                demand: [
                    { required: true, message: '请输入您的需求', trigger: 'blur' }
                ],
                agreement: [
                    { required: true, type: 'boolean', validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error('请勾选同意协议'));
                        } else {
                            callback();
                        }
                    }, trigger: 'change' }
                ]
            },
            dialogVisible: false, // 新增：控制提交成功弹窗
        };
    },
    methods: {
        closeDialog() {
            this.$emit('close');
        },
        handleDialogClose() {
            // 关闭弹窗时，通知父组件将visible设为false
            this.$emit('update:visible', false);
            this.$emit('close');
        },
        handleSubmit() {
            if (!this.form.agreement) return;
            this.$refs.dialogForm.validate((valid) => {
                if (valid) {
                    // 格式化 appointmentTime 为 YYYY-MM-DD
                    if (this.form.appointmentTime) {
                        const d = new Date(this.form.appointmentTime);
                        const yyyy = d.getFullYear();
                        const mm = String(d.getMonth() + 1).padStart(2, '0');
                        const dd = String(d.getDate()).padStart(2, '0');
                        this.form.appointmentTime = `${yyyy}-${mm}-${dd}`;
                    }

                    // this.dialogVisible = true; // 显示成功弹窗
                    // this.visible = false; // 主弹窗关闭
                    const { result } = consultationLogAdd(this.form);
                     this.$emit('submit');
                } else {
                    console.error('表单验证失败');
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
/* 将背景图应用到整个弹窗 */
::v-deep .el-dialog {
    background-image: url('../../assets/home/ziXunDiag.png');
    background-size: cover;
    background-position: center;
    /* 可选：添加半透明遮罩提升内容可读性 */
    position: relative;
    /* 保证内容层级正常 */
    z-index: auto;
}

::v-deep .el-input__inner {
    border: none;
}

::v-deep .el-dialog__body {
    padding-right: 210px;
}

::v-deep .el-dialog__header {
    padding: 32px !important;
}

/* 可选：为内容添加半透明背景提升可读性 */
.dialog-content {
    // background: rgba(255,255,255,0.85);
    padding: 32px;
    padding-right: 240PX;
    position: static;
    z-index: auto;
}

/* 新增：提高弹窗z-index，确保显示在最上面 */
//  .el-dialog__wrapper {
//     z-index: 3000 !important;
// }

.dialog-footer {
    display: flex;
    justify-content: flex-start;
    margin-top: 24px;

    .el-button {
        margin-left: 10px;
    }
}

/* 新增表单布局样式 */
.half-width {
    width: 48%;
    display: inline-block;
    margin-right: 24px;
    vertical-align: top;
}

.full-width {
    // width: 98%;
    display: block;
    // margin: 0 auto;
}

/* 让最后一行不换行 */
.half-width:nth-child(2n) {
    margin-right: 0;
}

.header {
    z-index: 100 !important;
}




::v-deep .el-dialog__header {
    padding: 32px 32px 10px !important;
    opacity: 1;

font-family: PingFang SC;
font-size: 18px;
font-weight: bold;
line-height: normal;
letter-spacing: 0px;

color: #3D3D3D;
}


::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #606266;
}
</style>
